/**
 * Wrapper for dashboard charts with consistent styling and sizing.
 * Supports fullWidth for time-series charts that benefit from wider display.
 */
export default function ChartCard({ title, children, fullWidth = false, height = 280 }) {
  return (
    <div
      style={{
        background: '#ffffff',
        border: '1px solid #e2e8f0',
        borderRadius: '10px',
        padding: '1.25rem',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -2px rgba(0, 0, 0, 0.05)',
        transition: 'transform 0.2s, box-shadow 0.2s, border-color 0.2s',
        gridColumn: fullWidth ? '1 / -1' : undefined,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0,0,0,0.08)';
        e.currentTarget.style.borderColor = '#0ea5e9';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'none';
        e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -2px rgba(0, 0, 0, 0.05)';
        e.currentTarget.style.borderColor = '#e2e8f0';
      }}
    >
      <h3
        style={{
          fontFamily: "'DM Sans', sans-serif",
          fontSize: '1rem',
          fontWeight: 600,
          color: '#1e293b',
          marginBottom: '1rem',
        }}
      >
        {title}
      </h3>
      <div style={{ height, minHeight: height, width: '100%' }}>
        {children}
      </div>
    </div>
  );
}
